import { gql } from '@apollo/client';
export const documentQuery = gql `
  query GetDocumentName($id: ID!) {
    fileSystemDocument: fileSystemDocument(id: $id) {
      id
      name
    }
  }
`;
